export function filteredGroupsGetter( state ) {
    let groups = state.groups
    //con esto filtro los resultado por el name del group, no es case sensitive
    if( state.filter.query.length > 1 ){
        groups = groups.filter( group => group.name.toLowerCase().includes( state.filter.query.toLowerCase() ) )        
    }
    return groups
}